<template>
  <div>
    <CRow>
      <CCol col="12">
        <CCard class="shadow-sm border-0">
          <CCardHeader
            style="background-color: #145654"
            class="d-flex justify-content-between align-items-center px-3 py-3"
          >
            <h4 class="card-title mb-0 text-white d-flex align-items-center">
              <CIcon name="cil-window-restore" size="xl" class="mr-2 icon-header" /> 
              <span class="header-text">{{ $t('reportList.pageTitle') }}</span>
            </h4>
            <button class="report-btn" @click="checkBeforeReport">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                <polyline points="14 2 14 8 20 8" />
                <line x1="12" y1="18" x2="12" y2="12" />
                <line x1="9" y1="15" x2="15" y2="15" />
              </svg>
              <span>{{ $t('reportList.newRequest') }}</span>
            </button>
          </CCardHeader>

          <CCardBody class="p-2 p-md-4">
            <div class="custom-tabs">
              <div class="tabs-scroll-container">
                <div class="tabs-header">
                  <button :class="['tab-item', { active: activeTab === 'report' }]" @click="activeTab = 'report'">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="tab-icon">
                      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                      <polyline points="14 2 14 8 20 8" />
                    </svg>
                    <span>{{ $t('reportList.tabActive') }}</span>
                  </button>
                  <button :class="['tab-item', { active: activeTab === 'history' }]" @click="activeTab = 'history'">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="tab-icon">
                      <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
                      <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
                    </svg>
                    <span>{{ $t('reportList.tabHistory') }}</span>
                  </button>
                </div>
              </div>

              <div class="tabs-content mt-3">
                <div v-show="activeTab === 'report'" class="table-responsive-wrapper">
                  <Treportable ref="tReportTable" @show-detail="handleShowDetail" />
                </div>
                <div v-show="activeTab === 'history'" class="table-responsive-wrapper">
                  <Thistorytable ref="tHistoryTable" @show-detail="handleShowDetail" />
                </div>
              </div>
            </div>
          </CCardBody>
        </CCard>

        <transition name="fade">
          <div id="detail-section" v-if="selectedReport" class="mt-4 mb-5 px-0">
            <ReportDetail 
              :report="selectedReport" 
              :isReporter="selectedReport && selectedReport._role === 'reporter'"
              @close="closeDetail"
              @refresh="refreshTables"
            />
          </div>
        </transition>

      </CCol>
    </CRow>

    <SendReport v-model="sendReportModal" @ticket-created="handleTicketCreated" />
  </div>
</template>

<script>
import Thistorytable from "../../components/technician/Thistorytable.vue";
import Treportable from "../../components/technician/Treportable.vue";
import ReportDetail from "./ReportDetail.vue";
import SendReport from "../../components/user/SendReport";
import { getSocket } from "@/service/socketio.service";
import Swal from 'sweetalert2';

export default {
  name: "Dashboard",
  components: {
    Treportable,
    Thistorytable,
    ReportDetail,
    SendReport,
  },
  mounted() {
    const socket = getSocket();
    if (socket) {
      socket.on("technician_new_job", (data) => {
        console.log("New job received:", data);
        this.refreshTables();
      });
      // Optionally listen for general updates if needed
      socket.on("ticket_updated", (data) => {
        this.refreshTables();
        if (this.selectedReport && this.selectedReport._id === data._id) {
          if (data.status === 'cancelled') {
            this.selectedReport = null;
            Swal.fire({
              icon: 'info',
              title: this.$t('mainuser.ticketCancelledTitle'),
              text: this.$t('mainuser.ticketCancelledText'),
              confirmButtonColor: '#3085d6',
            });
          } else {
            this.selectedReport = { ...this.selectedReport, ...data };
          }
        }
      });
    }
  },
  beforeDestroy() {
     const socket = getSocket();
    if (socket) {
      socket.off("technician_new_job");
      socket.off("ticket_updated");
    }
  },
  data() {
    return {
      activeTab: "report",
      selectedReport: null,
      sendReportModal: false,
    };
  },
  methods: {
    handleShowDetail(item) {
      this.selectedReport = item;
      this.$nextTick(() => {
        const element = document.getElementById("detail-section");
        if (element) {
          const yOffset = -70; // เลื่อนขึ้นอีกนิดให้เห็นหัวข้อชัดเจนบนมือถือ
          const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
          window.scrollTo({top: y, behavior: 'smooth'});
        }
      });
    },
    closeDetail() {
      this.selectedReport = null;
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    refreshTables() {
      if (this.$refs.tReportTable) {
        this.$refs.tReportTable.loadTickets();
      }
      if (this.$refs.tHistoryTable) {
        this.$refs.tHistoryTable.loadTechnicianHistory();
      }
    },
    handleTicketCreated() {
      if (this.$refs.tReportTable) {
        this.$refs.tReportTable.loadTickets();
      }
      if (this.$refs.tHistoryTable) {
        this.$refs.tHistoryTable.loadTechnicianHistory();
      }
    },
    async checkBeforeReport() {
      const userStr = localStorage.getItem('user');
      const userId = userStr ? JSON.parse(userStr)._id : null;
      if (!userId) {
        this.sendReportModal = true;
        return;
      }
      try {
        const response = await fetch(`${process.env.VUE_APP_APP_URL}/ticket/user/${userId}/active`);
        if (response.ok) {
          const data = await response.json();
          if (data.success && Array.isArray(data.data)) {
            const unevaluatedTicket = data.data.find(t => t.status === 'done');
            if (unevaluatedTicket) {
              Swal.fire({
                icon: 'warning',
                title: this.$t('mainuser.evalBeforeNewTitle'),
                text: this.$t('mainuser.evalBeforeNewText'),
                confirmButtonColor: '#2ba9a5',
                confirmButtonText: this.$t('login.ok'),
                returnFocus: false
              }).then(() => {
                this.handleShowDetail(unevaluatedTicket);
              });
              return;
            }
          }
        }
      } catch (err) {
        console.error("Error checking unevaluated tickets", err);
      }
      this.sendReportModal = true;
    }
  },
};
</script>

<style scoped>
/* --- Styles Desktop (Default) --- */
.custom-tabs { margin-top: 10px; width: 100%; }

.report-btn {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 24px;
  border: none;
  border-radius: 50px;
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 4px 15px rgba(16, 185, 129, 0.4);
  transition: all 0.3s ease;
  animation: pulse-glow 2s ease-in-out infinite;
  white-space: nowrap;
}

.report-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(16, 185, 129, 0.5);
  animation: none;
}

.report-btn:active {
  transform: translateY(0);
}

@keyframes pulse-glow {
  0%, 100% {
    box-shadow: 0 4px 15px rgba(16, 185, 129, 0.4);
    transform: scale(1);
  }
  50% {
    box-shadow: 0 6px 30px rgba(16, 185, 129, 0.8), 0 0 50px rgba(16, 185, 129, 0.5);
    transform: scale(1.05);
  }
}

.tabs-header { 
  display: flex; 
  gap: 15px; 
  border-bottom: 2px solid #e9ecef; 
  margin-bottom: 20px; 
}

/* ใช้ ::v-deep เพื่อเจาะเข้าไปแก้ไข CSS ของ CDataTable ที่ซ่อนอยู่ 
   ปัญหามือถือส่วนใหญ่เกิดจากช่อง Filter ของ CDataTable กว้างเกินไป
*/
::v-deep .table-responsive-wrapper {
  width: 100%;
}

.tab-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 20px;
  border: none;
  background: transparent;
  color: #6c757d;
  cursor: pointer;
  border-bottom: 3px solid transparent;
  transition: all 0.3s ease;
  font-size: 16px;
  font-weight: 500;
  outline: none;
}

.tab-item:hover {
  color: #495057;
  background-color: #f8f9fa;
  border-radius: 8px 8px 0 0;
}

.tab-item.active {
  color: #145654;
  font-weight: 700;
  border-bottom-color: #2ba9a5;
  background-color: rgba(43, 169, 165, 0.08);
  border-radius: 8px 8px 0 0;
}

.tab-icon { width: 20px; height: 20px; }

/* Animation */
.fade-enter-active, .fade-leave-active { transition: opacity 0.3s; }
.fade-enter, .fade-leave-to { opacity: 0; }

/* --- Mobile Responsive Fixes --- */
@media (max-width: 768px) {
  
  .card-title { font-size: 1.1rem; }
  .icon-header { width: 22px !important; height: 22px !important; }

  /* ปรับ Tabs ให้ Scroll ได้ และจัดระยะห่างใหม่ */
  .tabs-scroll-container {
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    padding-bottom: 5px;
  }

  .tabs-header {
    gap: 5px;
    margin-bottom: 15px;
    border-bottom: 1px solid #e9ecef;
    min-width: 100%; /* ให้เต็มความกว้าง */
    justify-content: space-between;
  }
  
  .tab-item {
    flex: 1; /* แบ่งพื้นที่เท่ากัน */
    justify-content: center;
    padding: 10px 5px;
    font-size: 0.9rem;
    white-space: nowrap;
  }

  .tab-item span { font-size: 14px; }
  .tab-icon { width: 18px; height: 18px; }
  
  /* 🔥🔥🔥 ส่วนสำคัญ: แก้ไข Layout ของ CDataTable บนมือถือ 🔥🔥🔥 */
  /* บังคับให้ส่วน Filter และ Pagination เรียงแนวตั้งและเต็มความกว้าง */
  ::v-deep .row {
    margin-left: 0;
    margin-right: 0;
  }
  
  /* ตัว Filter (กล่องค้นหา) */
  ::v-deep .col-sm-12, ::v-deep .col-md-6 {
    padding-left: 0;
    padding-right: 0;
    width: 100%;
    flex: 0 0 100%;
    max-width: 100%;
    margin-bottom: 10px;
  }

  ::v-deep .form-inline {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
  }

  ::v-deep .form-inline label {
    margin-bottom: 5px;
    font-size: 0.85rem;
  }

  ::v-deep .form-inline input.form-control, 
  ::v-deep .form-inline select.form-control {
    width: 100% !important; /* บังคับให้ช่องกรอกกว้างเต็มจอ */
    display: block;
  }

  /* จัดการ Pagination ด้านล่าง */
  ::v-deep .pagination {
    justify-content: center;
    flex-wrap: wrap;
  }
}
</style>